/// <amd-module name="typeahead/dataprovider/uta/ChildSuggestionsToggle" />
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

export class ChildSuggestionsToggle {

    public readonly OPEN_CLASS = "show-more-icon";
    public readonly COLLAPSE_CLASS = "collapse-icon";
    private readonly DEFAULT_CLASSES = "icon chevron-icon";

    private readonly childElements;
    private readonly showMoreElement;
    private readonly firstSuggestionElement;

    constructor($dropDownElement: any, labelText: string) {
        this.childElements = $dropDownElement.find("li:has(a>.child-suggestion)");
        this.firstSuggestionElement = $dropDownElement.find("li.results-item:first");
        this.showMoreElement =
            $(`<div class="${this.DEFAULT_CLASSES}"
                            style="margin: 0 0.76923077em; padding: 0 1px; border-radius: 12px">
                            <svg class="uitk-icon-svg" style="font-size: 20px; top: 6px" role="img">
                                <title>${labelText}</title>
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#uitk-icon-toggle180"></use>
                            </svg>
                        </div>`);
        this.initState();
    }

    public hideChildren(): void {
        this.childElements.slideUp("fast", () => this.setOpenClass());
        this.showMoreElement.addClass(TypeaheadUtils.responsiveTAClasses.hlClass);
    }

    public showChildren(): void {
        this.childElements.slideDown("fast", () => this.setCloseClass());
        this.showMoreElement.addClass(TypeaheadUtils.responsiveTAClasses.hlClass);
    }

    private initState() {
        this.addChevron();
        this.childElements.css("display", "none");
        this.setOpenClass();
    }

    private addChevron(): void {
        // Handles flights and consistent display TnL - Multi line display name
        if (this.firstSuggestionElement.find("div.multiLineDisplay").length !== 0) {
            this.firstSuggestionElement.find("div.multiLineDisplay").find("br").before(this.showMoreElement);
        } else {
            // Handles hotel lob - single line display name.
            this.firstSuggestionElement.find("div.singleLineText").append(this.showMoreElement);
            this.firstSuggestionElement.find(".icon").first().css("top", "6px");
        }
    }

    private setOpenClass(): void {
        this.showMoreElement.removeClass(this.COLLAPSE_CLASS);
        this.showMoreElement.addClass(this.OPEN_CLASS);
        this.showOpenIcon();
    }

    private showOpenIcon(): void {
        this.showMoreElement.find("svg>use").attr("xlink:href", "#uitk-icon-toggle180");
    }

    private setCloseClass(): void {
        this.showMoreElement.removeClass(this.OPEN_CLASS);
        this.showMoreElement.addClass(this.COLLAPSE_CLASS);
        this.showCloseIcon();
    }

    private showCloseIcon(): void {
        this.showMoreElement.find("svg>use").attr("xlink:href", "#uitk-icon-toggle0");
    }
}
